<template>
    <div class="page mergedExport">
        <page-header :bread-crumb="true" :back-button="true" />
        <div class="wrap">
            <div class="searchBox">
                <el-select
                    class="space"
                    v-model="searchBox.query_time_type"
                    size="small"
                    style="width: 120px"
                >
                    <el-option
                        v-for="item in timeTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
                <el-date-picker
                    class="space"
                    @change="onPick"
                    v-model="pickerDates"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                    type="datetimerange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    size="small"
                    style="width: 350px"
                    :clearable="false"
                    :picker-options="pickerOptions"
                >
                </el-date-picker>
                <el-select
                    class="space"
                    size="small"
                    v-model="memberType"
                    style="width: 120px"
                >
                    <el-option
                        v-for="item in memberTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
                <el-select
                    v-show="[0, 1, 2].includes(memberType)"
                    ref="remoteSelect"
                    class="space"
                    size="small"
                    v-model="searchBox.merchant_id"
                    filterable
                    clearable
                    remote
                    reserve-keyword
                    :placeholder="`请输入${memberTypeList[memberType].label}搜索用户`"
                    :remote-method="remoteMethod"
                    :loading="selectLoading"
                    @hook:mounted="cancalReadOnly"
                    @visible-change="cancalReadOnly"
                    style="width: 260px"
                >
                    <el-option
                        v-for="item in memberList"
                        :key="item.id"
                        :label="item.dname"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
                <el-input
                    v-show="memberType === 3"
                    class="space"
                    v-model="searchBox.merchant_id"
                    size="small"
                    clearable
                    placeholder="请输入用户ID"
                    style="width: 260px"
                ></el-input>
                <button class="search f14h20w400" @click="exportEvent">导出</button>
            </div>
        </div>
    </div>
</template>

<script>
import { LOGIN_URL } from "@/common/config";
import { Message } from "element-ui";
import { getTodayBegin, getTodayEnd } from "@/helper/datetime";
import { createExportTask } from "@/api/order";
import { queryMemberByCondition } from "@/api/admin";

export default {
    name: "mergedExport",
    data() {
        return {
            memberTypeList: [
                { value: 0, label: "账号" },
                { value: 1, label: "手机号" },
                { value: 2, label: "名称" },
                { value: 3, label: "用户ID" },
            ],
            memberType: 0,
            memberList: [],
            selectLoading: false,
            searchBox: {
                merchant_id: "",
                begin_time: "",
                end_time: "",
                query_time_type: 1, // 1=创建时间 2=最后更新时间
            },
            timeTypeList: [
                { value: 1, label: "创建时间" },
                { value: 2, label: "最后更新时间" },
            ],
            pickerDates: [],
            pickerMinDate: "",
            pickerOptions: {
                onPick: ({ minDate, maxDate }) => {
                    if (minDate) {
                        this.pickerMinDate = minDate.getTime();
                    }
                    if (maxDate) {
                        this.pickerMinDate = "";
                    }
                },
                disabledDate: (time) => {
                    if (this.pickerMinDate) {
                        const oneDay = 24 * 3600 * 1000;
                        const maxRange = 30 * oneDay;
                        const minTime = this.pickerMinDate - maxRange;
                        const maxTime = this.pickerMinDate + maxRange;
                        return (
                            time.getTime() < minTime ||
                            time.getTime() > maxTime
                        );
                    }
                    return false;
                },
            },
        };
    },
    mounted() {
        this.getDate();
    },
    methods: {
        getDate() {
            const date_begin = getTodayBegin();
            const date_end = getTodayEnd();
            this.pickerDates = [date_begin, date_end];
            this.searchBox.begin_time = date_begin;
            this.searchBox.end_time = date_end;
        },
        onPick(val) {
            if (!val || !Array.isArray(val)) {
                this.searchBox.begin_time = "";
                this.searchBox.end_time = "";
                return;
            }
            this.searchBox.begin_time = val[0];
            this.searchBox.end_time = val[1];
        },
        async exportEvent() {
            const { searchBox } = this;
            if (!searchBox.merchant_id) {
                Message.error("请选择或输入商户信息");
                return;
            }
            const beginTime = new Date(searchBox.begin_time).getTime();
            const endTime = new Date(searchBox.end_time).getTime();
            const maxRange = 31 * 24 * 3600 * 1000;
            if (endTime - beginTime > maxRange) {
                Message.error("开始结束时间范围最多只能选择31天");
                return;
            }
            const params = {
                ...searchBox,
                judge_type: 125, // 合并导出
            };
            const res = await createExportTask(params).catch((e) => e);
            if (res.code == 200) {
                this.$alert(
                    `您好，由于所下载的文件容量较大，已提交至后台进行打包压缩，压缩完毕后可去数据报表中心进行下载，唯一标识符：${res.data}`,
                    "下载提示",
                    {
                        confirmButtonText: "去数据报表中心",
                        callback: (action) => {
                            if (action == "confirm") {
                                window.open(`${LOGIN_URL}/new/downloadcenter.html`);
                            }
                        },
                    }
                );
            } else {
                Message.error(res.msg);
            }
        },
        async remoteMethod(val) {
            const pType = {
                0: "account",
                1: "mobile",
                2: "dname",
            };
            const params = {
                page_size: 100,
            };
            params[pType[this.memberType]] = val;
            this.selectLoading = true;
            const res = await queryMemberByCondition(params)
                .catch((e) => e)
                .finally(() => {
                    this.selectLoading = false;
                });
            this.selectLoading = false;
            if (res.code != 200) return;
            this.memberList = res.data;
        },
        cancalReadOnly(onOff) {
            this.$nextTick(() => {
                if (!onOff) {
                    const { remoteSelect } = this.$refs;
                    const input = remoteSelect.$el.querySelector(".el-input__inner");
                    input.removeAttribute("readonly");
                }
            });
        },
    },
};
</script>

<style scoped lang="scss">
@import "@/common/style.scss";
.mergedExport.page {
    overflow: auto;
    .wrap {
        min-height: 740px;
        border-radius: 2px;
        background: #ffffff;
        padding: 16px 16px 50px 16px;
        .searchBox {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .space {
                margin: 0 12px 12px 0;
            }
            .search {
                text-align: center;
                width: 56px;
                height: 32px;
                background: #4d7efa;
                border-radius: 2px;
                color: #ffffff;
                cursor: pointer;
                margin-bottom: 12px;
            }
        }
    }
}
</style>
